/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ReadyResponse = zod.object({
  status: zod.enum(['ready', 'not-ready', 'draining']),
  missing: zod.array(zod.string()).optional(),
});

export type ReadyResponse = zod.input<typeof ReadyResponse>;
export type ReadyResponseOutput = zod.output<typeof ReadyResponse>;
